import { IPeopleDashboardData } from 'src/apis/dashboard/dashboard.interfaces';
import { getDashboardNavigationPaths } from 'src/apis/dashboard/dashboard.helpers';
import dayjs from 'dayjs';

const navigationPaths = getDashboardNavigationPaths();

export const peopleDashboardNewMock: IPeopleDashboardData = {
  actionItems: {
    attendanceIssues: {
      todayAbsentees: 8,
      unexcusedAbsences: 3,
      items: [
        {
          id: 'absent-1',
          type: 'attendance_missing',
          title: 'Today\'s Absentees',
          description: '8 students/staff absent today',
          count: 8,
          priority: 'high',
          navigationPath: navigationPaths.students.attendance,
        },
        {
          id: 'unexcused-1',
          type: 'unexcused_absence',
          title: 'Unexcused Absences',
          description: '3 unexcused absences requiring follow-up',
          count: 3,
          priority: 'medium',
          navigationPath: navigationPaths.students.attendance,
        },
      ],
    },
    leaveRequests: {
      pendingCount: 5,
      items: [
        {
          id: 'leave-1',
          type: 'leave_request',
          title: 'Leave Request - Deepak Mehta',
          description: 'Sick leave request pending approval',
          count: 1,
          priority: 'medium',
          relatedEntityId: 'staff-001',
          relatedEntityName: 'Deepak Mehta',
          navigationPath: navigationPaths.staff.list,
        },
        {
          id: 'leave-2',
          type: 'leave_request',
          title: 'Leave Requests - Multiple Staff',
          description: '4 leave requests pending approval',
          count: 4,
          priority: 'medium',
          navigationPath: navigationPaths.staff.list,
        },
      ],
    },
    documentationGaps: {
      expiredDocuments: 7,
      missingHealthRecords: 12,
      incompleteProfiles: 3,
      items: [
        {
          id: 'doc-1',
          type: 'document_expired',
          title: 'Expired Documents',
          description: '7 documents require renewal',
          count: 7,
          priority: 'low',
          navigationPath: navigationPaths.students.list,
        },
        {
          id: 'health-1',
          type: 'health_record_missing',
          title: 'Missing Health Records',
          description: '12 students missing health records',
          count: 12,
          priority: 'medium',
          navigationPath: navigationPaths.students.list,
        },
      ],
    },
  },
  upcomingItems: {
    milestones: [
      {
        id: 'anniversary-1',
        type: 'work_anniversary',
        title: 'Work Anniversary - Sunita Iyer',
        description: '5 years of service',
        date: dayjs().add(3, 'days').toISOString(),
        relatedEntityId: 'staff-002',
        relatedEntityName: 'Sunita Iyer',
        years: 5,
        navigationPath: navigationPaths.staff.list,
      },
      {
        id: 'anniversary-2',
        type: 'work_anniversary',
        title: 'Work Anniversary - Manoj Pillai',
        description: '3 years of service',
        date: dayjs().add(7, 'days').toISOString(),
        relatedEntityId: 'staff-003',
        relatedEntityName: 'Manoj Pillai',
        years: 3,
        navigationPath: navigationPaths.staff.list,
      },
      {
        id: 'birthday-1',
        type: 'birthday',
        title: 'Birthday - Aishwarya Rao',
        description: 'Student birthday',
        date: dayjs().add(5, 'days').toISOString(),
        relatedEntityId: 'student-007',
        relatedEntityName: 'Aishwarya Rao',
        navigationPath: navigationPaths.students.list,
      },
    ],
    meetings: [
      {
        id: 'meeting-1',
        type: 'parent_teacher_meeting',
        title: 'Parent-Teacher Meeting - Class 10A',
        description: 'Scheduled parent-teacher meeting',
        date: dayjs().add(10, 'days').toISOString(),
        navigationPath: navigationPaths.events.meetings,
      },
      {
        id: 'meeting-2',
        type: 'parent_teacher_meeting',
        title: 'Parent-Teacher Meeting - Class 12B',
        description: 'Scheduled parent-teacher meeting',
        date: dayjs().add(15, 'days').toISOString(),
        navigationPath: navigationPaths.events.meetings,
      },
    ],
    reviews: [],
  },
  summary: {
    students: {
      total: 1250,
      active: 1200,
      inactive: 50,
      newEnrollments: 45,
      attendanceRate: 94.5,
    },
    staff: {
      total: 85,
      active: 80,
      onLeave: 5,
      attendanceRate: 96.2,
    },
    attendance: {
      totalPresent: 1200,
      totalAbsent: 65,
      totalLeave: 15,
      overallRate: 93.8,
    },
  },
  recentActivity: [
    {
      id: 'activity-1',
      type: 'enrollment',
      description: 'New enrollment - Varun Malhotra',
      timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
      relatedEntityName: 'Varun Malhotra',
      navigationPath: navigationPaths.students.list,
    },
    {
      id: 'activity-2',
      type: 'staff_joining',
      description: 'New staff member joined - Radhika Kapoor',
      timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
      relatedEntityName: 'Radhika Kapoor',
      navigationPath: navigationPaths.staff.list,
    },
    {
      id: 'activity-3',
      type: 'attendance_marked',
      description: 'Attendance marked for Class 10A',
      timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
      navigationPath: navigationPaths.students.attendance,
    },
  ],
  timeRange: {
    startDate: '2024-01-01',
    endDate: '2024-01-31',
  },
};
